'use client'

import { createContext } from 'react'

import type { RulesPayload } from './types'

const initialState = {
  rulesValidations: {}
} as RulesPayload

export const RulesContext = createContext<RulesPayload>(initialState)
